import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { SafeHtmlPipe } from './safe-html/safe-html';
import { SafePipe } from './safe/safe';
import { IsOpenPipe } from './is-open/is-open';
import { MomentDatePipe } from './moment-date/moment-date';
import { ReserveFieldRequiredPipe } from './reserve-field-required/reserve-field-required';
import { DurationConverterPipe } from './duration-converter/duration-converter';
import { DateRangeFormatPipe } from './date-range-format/date-range-format';
import { CoHtmlStringStripperPipe } from './co-html-string-stripper/co-html-string-stripper';
@NgModule({
	declarations: [SafeHtmlPipe,
    SafePipe,
    IsOpenPipe,
    MomentDatePipe,
    ReserveFieldRequiredPipe,
    DurationConverterPipe,
    DateRangeFormatPipe,
    CoHtmlStringStripperPipe],
	imports: [],
	exports: [SafeHtmlPipe,
    SafePipe,
    IsOpenPipe,
    MomentDatePipe,
    ReserveFieldRequiredPipe,
    DurationConverterPipe,
    DateRangeFormatPipe,
    CoHtmlStringStripperPipe],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts